import styled from '@emotion/styled'

/**
 * Legend 스타일 — 두 항목 가로 배치, 가운데 정렬 (Figma 17724:42255 기준).
 *  - 두 항목 사이 24px gap
 *  - 각 항목: 아이콘 12px + 텍스트 13px / gap 6px
 */

export const LegendWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
`

export const LegendItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const LegendText = styled.span`
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0;
  color: #3f4145;
`
